'use es6';

import http from 'hub-http/clients/apiClient';
import { Map as ImmutableMap } from 'immutable';
import formatPipelines from 'reference-resolvers/formatters/formatPipelines';
import formatPipelineStages from 'reference-resolvers/formatters/formatPipelineStages';
const formatResponse = response => {
  return ImmutableMap({
    pipelines: formatPipelines(response),
    stages: formatPipelineStages(response)
  });
};
export const createGetAllTicketPipelines = ({
  httpClient
}) => () => httpClient.get('pipelines/v2/pipelines/TICKET').then(formatResponse);
export const getAllTicketPipelines = createGetAllTicketPipelines({
  httpClient: http
});